export default "__VITE_ASSET__K9RWfNU9__"